
export const TYPES = {
  SET_FEATURE_FLAG: 'SET_FEATURE_FLAG',
};

export function setFeatureFlag(featureFlag) {
  return {
    type: TYPES.SET_FEATURE_FLAG,
    featureFlag,
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/featureFlagActions.js
 **/